"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
var sortable_table_hook_1 = require("./sortable-table.hook");
var sortable_table_types_1 = require("./sortable-table.types");
var table_component_1 = __importDefault(require("../table/table.component"));
function SortableTable(props) {
    var rows = props.rows;
    var columnSort = sortable_table_hook_1.useColumnSort(props.headers);
    var currentSortColumn = columnSort.currentSortColumn, sortDirection = columnSort.sortDirection;
    var sortedItems = react_1.useMemo(function () {
        if (!currentSortColumn)
            return rows;
        var sortedItems = rows;
        if (currentSortColumn.sortBy)
            sortedItems = lodash_1.default.sortBy(rows, [currentSortColumn.sortBy]);
        else if (currentSortColumn.sort)
            sortedItems = rows.sort(currentSortColumn.sort);
        return sortDirection === sortable_table_types_1.SortDirection.descending ? sortedItems.reverse() : sortedItems;
    }, [rows, sortDirection, currentSortColumn]);
    return react_1.default.createElement(table_component_1.default, __assign({}, props, columnSort, { rows: sortedItems }));
}
SortableTable.displayName = 'SortableTable';
exports.default = SortableTable;
//# sourceMappingURL=sortable-table.component.js.map